export var BoxMarkup;
(function (BoxMarkup) {
    BoxMarkup["DIV"] = "div";
    BoxMarkup["A"] = "a";
})(BoxMarkup || (BoxMarkup = {}));
//# sourceMappingURL=BoxProps.js.map